import { composeIO } from 'react-compose-io'
import { tabelaInternalizacaoIO } from './TabelaInternalizacao.IO'
import { TabelaInternalizacaoView } from './TabelaInternalizacao.View'

export const TabelaInternalizacao = composeIO(TabelaInternalizacaoView, tabelaInternalizacaoIO)
